import React, { useState } from "react";

const KEY = "gv_cookie_consent";
const DAYS = 90;

const accepted = () => {
  try {
    const t = Number(localStorage.getItem(KEY));
    return t && Date.now() - t < DAYS * 86400000;
  } catch { return false; }
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !accepted());
  const accept = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* storage blocked */ }
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-5 left-5 z-[60] bg-white rounded-2xl shadow-[0_15px_45px_rgba(0,0,0,0.2)] p-5 max-w-[320px] border border-gray-100">
      <p className="text-[#16243b] font-semibold text-[1rem]">This website uses cookies</p>
      <a href="#" className="text-[#2ec9c9] text-[0.85rem] hover:underline">Read our cookie policy</a>
      <div className="mt-3">
        <button
          onClick={accept}
          data-testid="cookie-accept-btn"
          className="gp-btn-teal rounded-full px-8 py-2 text-[0.9rem] font-medium"
        >
          Ok
        </button>
      </div>
    </div>
  );
}
